// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-sales-container-Bh7M2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  gap: 20px;
  height: 100vh;
  overflow: auto;
  background-color: var(--color-white);
  background-image:
    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),
    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),
    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);
  padding: 40px 24px;
}

.contact-sales-header-NnzvO {
  flex-shrink: 0;
  margin-bottom: 24px;
}

.contact-sales-content-oatxR {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 560px;
  max-width: 100%;
  text-align: center;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-3xl);
  padding: 32px;
}

.contact-sales-content-oatxR > * {
  flex-shrink: 0;
}

.contact-sales-iconContainer-lM0Rr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: var(--color-blue-50);
  border-radius: 50%;
}

.contact-sales-statusIcon-SCdnQ {
  --size: 40px;
  color: var(--color-blue-600);
}

.contact-sales-heroTitle-QJfHJ {
  color: var(--color-neutral-900);
  font-size: var(--text-xl);
  font-weight: var(--font-weight-medium);
  line-height: 1.25;
  margin: 24px 0px 0px;
}

.contact-sales-heroDescription-Nvbp5,
.contact-sales-activationDescription-sNlhZ {
  color: var(--color-neutral-600);
  font-size: 15px;
  line-height: 1.5;
}

.contact-sales-heroDescription-Nvbp5 {
  margin: 20px 0px 0px;
}

.contact-sales-activationDescription-sNlhZ {
  margin: 12px 0px 0px;
}

.contact-sales-contactWhatsapp-YIJkc {
  font-size: var(--text-sm);
  line-height: 1.5;
  cursor: pointer;
  margin: 8px 0px 0px;
}

.contact-sales-contactWhatsapp-YIJkc a {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: var(--font-weight-medium);
}

.contact-sales-contactWhatsappIcon-iH73t {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

.contact-sales-safetySection-H53eH {
  width: 100%;
  max-width: 460px;
  text-align: left;
  background-color: var(--color-amber-50);
  border: 1px solid var(--color-amber-200);
  border-radius: var(--radius-xl);
  padding: 16px;
  margin-top: 28px;
}

.contact-sales-safetyHeader-GyPCv {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-sales-safetyIcon-MhOAn {
  --size: 20px;
  color: var(--color-amber-700);
}

.contact-sales-safetyTitle-Bg2Yx {
  color: var(--color-amber-900);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  margin: 0px;
}

.contact-sales-safetyList-qmZ77 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 18px;
  margin: 16px 0px 0px 8px;
}

.contact-sales-safetyItem-w3di_ {
  color: var(--color-amber-950);
  font-size: var(--text-sm);
  line-height: 1.5;
}

.contact-sales-safetyItem-w3di_::marker {
  color: var(--color-amber-800);
}

.contact-sales-safetyItem-w3di_ b {
  font-weight: var(--font-weight-medium);
}

.contact-sales-officialChannel-jEzUq {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-amber-800);
  border-top: 1px solid var(--color-amber-200);
  padding-top: 12px;
  margin-top: 14px;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
}

.contact-sales-officialChannelIcon-TROPx {
  --size: 15px;
}

.contact-sales-salesButton-mytOQ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 380px;
  max-width: 100%;
  min-height: 44px;
  color: var(--color-white);
  font-family: inherit;
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  background-color: var(--color-blue-500);
  border: 1px solid var(--color-blue-500);
  border-radius: var(--radius-md);
  padding: 10px 16px;
  margin-top: 28px;
  cursor: pointer;
  text-decoration: none;
}

.contact-sales-salesButton-mytOQ:hover {
  text-decoration: none;
}

.contact-sales-salesButton-mytOQ:active {
  background-color: var(--color-blue-600);
}

.contact-sales-salesButtonIcon-d5R56 {
  --size: 24px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/contact-sales/contact-sales.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC;;;+HAG6H;EAC7H,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: safe center;\n  gap: 20px;\n  height: 100vh;\n  overflow: auto;\n  background-color: var(--color-white);\n  background-image:\n    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),\n    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),\n    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);\n  padding: 40px 24px;\n}\n\n.header {\n  flex-shrink: 0;\n  margin-bottom: 24px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 560px;\n  max-width: 100%;\n  text-align: center;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--radius-3xl);\n  padding: 32px;\n}\n\n.content > * {\n  flex-shrink: 0;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background-color: var(--color-blue-50);\n  border-radius: 50%;\n}\n\n.statusIcon {\n  --size: 40px;\n  color: var(--color-blue-600);\n}\n\n.heroTitle {\n  color: var(--color-neutral-900);\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.25;\n  margin: 24px 0px 0px;\n}\n\n.heroDescription,\n.activationDescription {\n  color: var(--color-neutral-600);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.heroDescription {\n  margin: 20px 0px 0px;\n}\n\n.activationDescription {\n  margin: 12px 0px 0px;\n}\n\n.contactWhatsapp {\n  font-size: var(--text-sm);\n  line-height: 1.5;\n  cursor: pointer;\n  margin: 8px 0px 0px;\n}\n\n.contactWhatsapp a {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: var(--font-weight-medium);\n}\n\n.contactWhatsappIcon {\n  width: 18px;\n  height: 18px;\n  fill: currentColor;\n}\n\n.safetySection {\n  width: 100%;\n  max-width: 460px;\n  text-align: left;\n  background-color: var(--color-amber-50);\n  border: 1px solid var(--color-amber-200);\n  border-radius: var(--radius-xl);\n  padding: 16px;\n  margin-top: 28px;\n}\n\n.safetyHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.safetyIcon {\n  --size: 20px;\n  color: var(--color-amber-700);\n}\n\n.safetyTitle {\n  color: var(--color-amber-900);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  margin: 0px;\n}\n\n.safetyList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-left: 18px;\n  margin: 16px 0px 0px 8px;\n}\n\n.safetyItem {\n  color: var(--color-amber-950);\n  font-size: var(--text-sm);\n  line-height: 1.5;\n}\n\n.safetyItem::marker {\n  color: var(--color-amber-800);\n}\n\n.safetyItem b {\n  font-weight: var(--font-weight-medium);\n}\n\n.officialChannel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--color-amber-800);\n  border-top: 1px solid var(--color-amber-200);\n  padding-top: 12px;\n  margin-top: 14px;\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-medium);\n}\n\n.officialChannelIcon {\n  --size: 15px;\n}\n\n.salesButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 380px;\n  max-width: 100%;\n  min-height: 44px;\n  color: var(--color-white);\n  font-family: inherit;\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  background-color: var(--color-blue-500);\n  border: 1px solid var(--color-blue-500);\n  border-radius: var(--radius-md);\n  padding: 10px 16px;\n  margin-top: 28px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.salesButton:hover {\n  text-decoration: none;\n}\n\n.salesButton:active {\n  background-color: var(--color-blue-600);\n}\n\n.salesButtonIcon {\n  --size: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `contact-sales-container-Bh7M2`,
	"header": `contact-sales-header-NnzvO`,
	"content": `contact-sales-content-oatxR`,
	"iconContainer": `contact-sales-iconContainer-lM0Rr`,
	"statusIcon": `contact-sales-statusIcon-SCdnQ`,
	"heroTitle": `contact-sales-heroTitle-QJfHJ`,
	"heroDescription": `contact-sales-heroDescription-Nvbp5`,
	"activationDescription": `contact-sales-activationDescription-sNlhZ`,
	"contactWhatsapp": `contact-sales-contactWhatsapp-YIJkc`,
	"contactWhatsappIcon": `contact-sales-contactWhatsappIcon-iH73t`,
	"safetySection": `contact-sales-safetySection-H53eH`,
	"safetyHeader": `contact-sales-safetyHeader-GyPCv`,
	"safetyIcon": `contact-sales-safetyIcon-MhOAn`,
	"safetyTitle": `contact-sales-safetyTitle-Bg2Yx`,
	"safetyList": `contact-sales-safetyList-qmZ77`,
	"safetyItem": `contact-sales-safetyItem-w3di_`,
	"officialChannel": `contact-sales-officialChannel-jEzUq`,
	"officialChannelIcon": `contact-sales-officialChannelIcon-TROPx`,
	"salesButton": `contact-sales-salesButton-mytOQ`,
	"salesButtonIcon": `contact-sales-salesButtonIcon-d5R56`
};
export default ___CSS_LOADER_EXPORT___;
